import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

export interface ProgramaPesvPayload {
  consecutivo: string;
 // nombre_programa: number;
  tipo_programa: number;
 // riesgo_critico_asociado: number;
 // proceso: number;
  //area: number;
  //objetivo_pesv_relacionado: number;
  fecha_inicio: string;
  fecha_fin: string;
  objetivo_general: string;
  estado?: number;
}

export interface ProgramaPesv {
  consecutivo: string;
  nombreProgramaData: any;
  tipoProgramaData: any;
  id?: number,
  nombre_programa: number;
  tipo_programa: number;
  riesgo_critico_asociado: number;
  proceso: number;
  area: number;
  objetivo_pesv_relacionado: number;
  fecha_inicio: string;
  fecha_fin: string;
  objetivo_general: string;
  estado?: number;
}

export interface ResumenPrograma {
  totalIndicadores: number;
  totalActividades: number;
  actividadesEnEjecucion: number;
  totalSeguimientos: number;
  ultimoSeguimiento: string | null;
  totalEvaluaciones: number;
  ultimaEvaluacion: string | null;
  avanceGeneral: number;
  meta: string;
  totalEvidencias?: number;
}

export interface ProgramaPesvResponse {
  id?: number;
  message?: string;
  error?: string;
  data?: any;
  [key: string]: any;
}

@Injectable({
  providedIn: "root",
})
export class ProgramaPesvService {
  private readonly apiUrl = `${environment.apiUrl}/api/programa_pesv`;

  constructor(private http: HttpClient) {}

  getAll(): Observable<any> {
    return this.http.get<any>(this.apiUrl, { withCredentials: true });
  }

  getById(id: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/${id}`, { withCredentials: true });
  }

  create(payload: ProgramaPesvPayload): Observable<ProgramaPesvResponse> {
    return this.http.post<ProgramaPesvResponse>(this.apiUrl, payload, {
      withCredentials: true,
    });
  }

  update(id: number, payload: Partial<ProgramaPesvPayload>): Observable<ProgramaPesvResponse> {
    return this.http.put<ProgramaPesvResponse>(`${this.apiUrl}/${id}`, payload, {
      withCredentials: true,
    });
  }

  remove(id: number): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}/${id}`, { withCredentials: true });
  }

  changeEstado(id: number, estado: number): Observable<ProgramaPesvResponse> {
    return this.http.put<ProgramaPesvResponse>(
      `${this.apiUrl}/${id}/estado`,
      { estado },
      { withCredentials: true },
    );
  }

  getRelatedData(id: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/${id}/relaciones`, { withCredentials: true });
  }

  getConsecutivo(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/consecutivo`, { withCredentials: true });
  }

getResumenPrograma(id: number, desde?: string, hasta?: string): Observable<any> {
  let params = new HttpParams();
  if (desde) params = params.set('desde', desde);
  if (hasta) params = params.set('hasta', hasta);

  return this.http.get<any>(`${this.apiUrl}/resumen/${id}`, { params });
}
}